import {useAuth} from '@/hooks/useAuth'
import {useAppDispatch} from '@/store'
import {setDarkMode} from '@/store/slices/themeSlice'
import {AppHeaderV2, useTheme} from 'pepsico-ds'
import {PropsWithChildren} from 'react'

type HeaderProps = PropsWithChildren & {
  logo: string
  title: string
}

type DefaultThemeName = 'Light Peacock' | 'Dark Peacock' | 'DTC Joy' | 'PepsiConnect' | 'PFDS'

export const Header = ({title}: HeaderProps) => {
  const {userInfo, email, signOut} = useAuth()
  const {firstName, lastName} = userInfo
  const dispatch = useAppDispatch()
  const {setTheme, currentTheme} = useTheme()

  const fullName = !!firstName && !!lastName ? `${firstName} ${lastName}` : ''
  return (
    <>
      <header
        data-testid="header"
        className="min-w-screen flex h-16 items-center justify-between bg-neutral-800 px-6 text-white"
      >
        <AppHeaderV2
          appLogoProps={{appName: title, showIcon: false}}
          profileMenuProps={{
            profileDetails: {
              onClick: () => {},
              name: fullName,
              email: email ?? '',
            },
            options: [
              // Add user guide component Modal later.
              // {
              //   icon: 'info',
              //   id: 'userGuide',
              //   title: 'User Guide',
              //   type: 'default',
              // },
            ],
            showThemeSwitcher: true,
            switcher: {
              defaultSelection: currentTheme as 'Auto' | 'Light Peacock' | 'Dark Peacock',
              onUpdate: option => {
                // This is for Auto theme, we will set theme based on system preference, if user choose Auto, we will check operating system preference and set theme accordingly, if user choose Light Peacock or Dark Peacock, we will set theme accordingly, for now we will only have Light Peacock and Dark Peacock themes, so if user choose Auto, we will set theme to Light Peacock
                // const systemPrefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
                const isDark = option === 'Dark Peacock'
                setTheme(option as DefaultThemeName)
                dispatch(setDarkMode(isDark))
                document.documentElement.classList.toggle('dark', isDark)
              },
            },
            // onClickOption add to all items in dropdown list, we need to use id to identify which item is clicked, for logout we will call signOut function from useAuth
            onClickOption: (id: string) => {
              if (id === 'logout') {
                signOut()
              }
            },
          }}
        />
      </header>
    </>
  )
}
